module.exports = __webpack_public_path__ + "static/media/card1_4.9c93a652.png";